// #1078 hidden の <input type="file">(ERB 側で描画、name を持つ)へファイルを流し込む。
// React 側のドロップゾーン/ボタンからは DOM の input を経由してフォーム送信に載せる。
export function openFilePicker(inputId) {
  const input = document.getElementById(inputId)
  if (input) input.click()
}

// ドラッグ&ドロップされた FileList を input に代入し、change を発火して購読側(プレビュー等)に知らせる。
// input.files への代入は主要ブラウザで可能(Safari 14.1+)。できない環境では何もしない。
export function assignDroppedFiles(inputId, fileList) {
  const input = document.getElementById(inputId)
  if (!input || !fileList || fileList.length === 0) return false
  try {
    input.files = fileList
  } catch (e) {
    return false
  }
  input.dispatchEvent(new Event('change', { bubbles: true }))
  return true
}

// ドラッグ中の見た目切り替えとドロップ処理をまとめたハンドラ群
export function dropHandlers(inputId, setDragging) {
  return {
    onDragOver: (e) => {
      e.preventDefault()
      setDragging(true)
    },
    onDragLeave: (e) => {
      e.preventDefault()
      setDragging(false)
    },
    onDrop: (e) => {
      e.preventDefault()
      setDragging(false)
      assignDroppedFiles(inputId, e.dataTransfer.files)
    },
  }
}
